import MessageBus from '@gaming/mtt-postal-kit';
import { PORTS_UNSUBSCRIBE, PORTS_SUBSCRIBE, PORTS_INVOKE } from './topics';
import { request as mbRequest } from '../utils/message-bus';

const portsApi = {
  invoke(resource, args = []) {
    const typeofResource = typeof resource;
    if (typeofResource !== 'string') {
      return Promise.reject(
        new Error(
          `"resource" passed to "invoke" must be a string. Got ${typeofResource} instead`
        )
      );
    }

    if (!Array.isArray(args)) {
      return Promise.reject(
        new Error(
          `"args" passed to "invoke" must be an array. Got ${typeof args} instead`
        )
      );
    }

    return mbRequest({
      topic: PORTS_INVOKE,
      data: {
        resource,
        args,
      },
    });
  },

  on(resource, callback, args = []) {
    const typeofCallback = typeof callback;
    if (typeofCallback !== 'function') {
      return Promise.reject(
        new Error(
          `"callback" passed to "on" must be a function. Got ${typeofCallback} instead`
        )
      );
    }

    const typeofResource = typeof resource;
    if (typeofResource !== 'string') {
      return Promise.reject(
        new Error(
          `"resource" passed to "on" must be a string. Got ${typeofResource} instead`
        )
      );
    }

    if (!Array.isArray(args)) {
      return Promise.reject(
        new Error(
          `"args" passed to "on" must be an array. Got ${typeof args} instead`
        )
      );
    }

    return mbRequest({
      topic: PORTS_SUBSCRIBE,
      data: {
        resource,
        args,
      },
    }).then(({ listenerTopic }) => {
      const listenerSubscription = MessageBus.subscribe({
        topic: listenerTopic,
        callback(data) {
          callback(data);
        },
      });

      return () => {
        MessageBus.unsubscribe(listenerSubscription);

        return mbRequest({
          topic: PORTS_UNSUBSCRIBE,
          data: { listenerTopic, resource },
        });
      };
    });
  },
};

export default portsApi;
